import { useTheme } from '../../context/ThemeContext';

const ClockIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const MyStoreWaiting = ({ refreshUserData, onSignOut, userData }) => {
  const { theme } = useTheme();

  const businessName = userData?.location_data?.business_name || 'Your store';

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: theme.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
    },
    card: {
      width: '100%',
      maxWidth: 440,
      textAlign: 'center',
    },
    iconCircle: {
      width: 80,
      height: 80,
      borderRadius: '50%',
      backgroundColor: 'rgba(245, 158, 11, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px',
      color: '#f59e0b',
    },
    title: {
      fontSize: 22,
      fontWeight: 700,
      color: theme.text,
      margin: '0 0 8px',
    },
    storeName: {
      fontSize: 15,
      fontWeight: 600,
      color: theme.accent,
      margin: '0 0 16px',
    },
    text: {
      fontSize: 14,
      color: theme.textSecondary,
      lineHeight: 1.5,
      margin: '0 0 24px',
    },
    infoBox: {
      padding: 16,
      borderRadius: 12,
      backgroundColor: theme.bgCard,
      border: `1px solid ${theme.border}`,
      textAlign: 'left',
      marginBottom: 24,
    },
    infoTitle: {
      fontSize: 14,
      fontWeight: 600,
      color: theme.text,
      margin: '0 0 10px',
    },
    infoItem: {
      fontSize: 13,
      color: theme.textSecondary,
      lineHeight: 1.6,
      margin: '0 0 6px',
      paddingLeft: 16,
      position: 'relative',
    },
    bullet: {
      position: 'absolute',
      left: 0,
    },
    checkBtn: {
      width: '100%',
      padding: 14,
      borderRadius: 12,
      border: 'none',
      backgroundColor: theme.accent,
      color: '#fff',
      fontSize: 16,
      fontWeight: 600,
      cursor: 'pointer',
      marginBottom: 12,
    },
    contactText: {
      fontSize: 12,
      color: theme.textMuted,
      marginBottom: 16,
    },
    signOutBtn: {
      width: '100%',
      padding: 12,
      borderRadius: 10,
      border: `1px solid ${theme.border}`,
      backgroundColor: 'transparent',
      color: theme.textSecondary,
      fontSize: 14,
      cursor: 'pointer',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <ClockIcon />
        </div>
        <h2 style={styles.title}>Application Under Review</h2>
        <p style={styles.storeName}>{businessName}</p>
        <p style={styles.text}>
          Our team is reviewing your application. We'll reach out if we need any additional information.
        </p>

        <div style={styles.infoBox}>
          <p style={styles.infoTitle}>What's Next?</p>
          <p style={styles.infoItem}>
            <span style={styles.bullet}>1.</span> We review your application (1-3 business days)
          </p>
          <p style={styles.infoItem}>
            <span style={styles.bullet}>2.</span> We may contact you to verify your business
          </p>
          <p style={styles.infoItem}>
            <span style={styles.bullet}>3.</span> Once approved, you'll sign the partner agreement
          </p>
          <p style={styles.infoItem}>
            <span style={styles.bullet}>4.</span> Your location dashboard goes live
          </p>
        </div>

        <button style={styles.checkBtn} onClick={refreshUserData}>
          Check Status
        </button>
        <p style={styles.contactText}>
          Questions? Contact us at support@cardchase.org
        </p>
        <button style={styles.signOutBtn} onClick={onSignOut}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default MyStoreWaiting;
